import { Button, styled } from '@material-ui/core';

const ActionButtonStyled = styled(Button)(({ version }) => ({
  border: '1px solid #5564F8',
  borderRadius: '1.25rem',
  fontWeight: 'normal',
  height: '2.8rem',
  padding: '0.5rem 0.9375rem',
  textTransform: 'none',

  ...(version === 'primary' && {
    '&:hover': {
      backgroundColor: '#3643b9',
      color: '#fff'
    },
    backgroundColor: '#5564F8',
    color: '#fff',
    marginLeft: '1rem'
  }),

  ...(version === 'secondary' && {
    backgroundColor: '#fff',
    color: '#5564F8',
    marginLeft: '1rem'
  }),
  ...(version === 'secondaryModified' && {
    backgroundColor: '#fff',
    color: '#000000',
    marginLeft: '1rem'
  }),
  ...(version === 'edit' && {
    backgroundColor: '#fff',
    borderColor: '#CAD8FF',
    color: '#000000'
  }),

  ...(version === 'ghost' && {
    '&:hover': {
      border: 'none'
    },
    background: 'transparent',
    border: 'none',
    borderColor: 'transparent',
    borderRadius: '8px',
    boxShadow: 'none'
  }),

  ...(version === 'cartBtn' && {
    background: '#fff',
    borderColor: '#CAD8FF',
    borderRadius: '0.625rem',
    boxShadow: 'none',
    height: '2.5rem',
    width: '4rem'
  }),

  ...(version === 'translateButton' && {
    backgroundColor: '#5564F8',
    borderColor: '#5564F8',
    borderRadius: '0.875rem',
    boxShadow: 'none',
    color: '#fff',
    fontSize: '0.75rem',
    height: '2rem',
    marginLeft: '1rem'
  }),

  '&:disabled': {
    backgroundColor: 'rgba(0,0,0,0.2)',
    border: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  }
}));

const ActionButton = ({ children, version, ...rest }) => (
  <ActionButtonStyled variant="outlined" version={version} {...rest}>
    {children}
  </ActionButtonStyled>
);

export default ActionButton;
